const depts = [
  {
    code: "01",
    Libelle: "OUEST",
    titre: "Direction departementale de l'Ouest",
  },
  { code: "02", Libelle: "NORD", titre: "Direction departementale du Nord" },
  {
    code: "03",
    Libelle: "SUD'EST",
    titre: "Direction departementale du Sud'Est",
  },
  {
    code: "04",
    Libelle: "NORD'EST",
    titre: "Direction departementale du Nord'Est",
  },
  {
    code: "05",
    Libelle: "ARTIBONITE",
    titre: "Direction departementale de l'Artibonite",
  },
  {
    code: "06",
    Libelle: "CENTRE",
    titre: "Direction departementale du Centre",
  },
  { code: "07", Libelle: "SUD", titre: "Direction departementale du Sud" },
  {
    code: "08",
    Libelle: "Grand'Anse",
    titre: "Direction departementale de la Grand-Anse",
  },
  {
    code: "09",
    Libelle: "NORD'OUEST",
    titre: "Direction departementale du Nord'Ouest",
  },
  {
    code: "10",
    Libelle: "NIPPES",
    titre: "Direction departementale des Nippes",
  },
];

const Annee_academique = [
  { an: "8081", libelle: "1980/1981" },
  { an: "8182", libelle: "1981/1982" },
  { an: "8283", libelle: "1982/1983" },
  { an: "8384", libelle: "1983/1984" },
  { an: "8485", libelle: "1984/1985" },

  { an: "8586", libelle: "1985/1986" },
  { an: "8687", libelle: "1986/1987" },
  { an: "8788", libelle: "1987/1988" },
  { an: "8889", libelle: "1988/1989" },
  { an: "8990", libelle: "1989/1990" },

  { an: "9091", libelle: "1990/1991" },
  { an: "9192", libelle: "1991/1992" },
  { an: "9293", libelle: "1992/1993" },
  { an: "9394", libelle: "1993/1994" },
  { an: "9495", libelle: "1994/1995" },

  { an: "9596", libelle: "1995/1996" },
  { an: "9697", libelle: "1996/1997" },
  { an: "9798", libelle: "1997/1998" },
  { an: "9899", libelle: "1998/1999" },
  { an: "9900", libelle: "1999/2000" },

  { an: "0001", libelle: "2000/2001" },
  { an: "0102", libelle: "2001/2002" },
  { an: "0203", libelle: "2002/2003" },
  { an: "0304", libelle: "2003/2004" },
  { an: "0405", libelle: "2004/2005" },
  { an: "0506", libelle: "2005/2006" },
  { an: "0607", libelle: "2006/2007" },
  { an: "0708", libelle: "2007/2008" },
  { an: "0809", libelle: "2008/2009" },
  { an: "0910", libelle: "2009/2010" },
  { an: "1011", libelle: "2010/2011" },
  { an: "1112", libelle: "2011/2012" },
  { an: "1213", libelle: "2012/2013" },
  { an: "1314", libelle: "2013/2014" },
  { an: "1415", libelle: "2014/2015" },
  { an: "1516", libelle: "2015/2016" },
  { an: "1617", libelle: "2016/2017" },
  { an: "1718", libelle: "2017/2018" },
  { an: "1819", libelle: "2018/2019" },
  { an: "1920", libelle: "2019/2020" },
  { an: "2021", libelle: "2020/2021" },
  { an: "2122", libelle: "2021/2022" },
  { an: "2223", libelle: "2022/2023" },
  { an: "2324", libelle: "2023/2024" },
  { an: "2425", libelle: "2024/2025" },
  { an: "2526", libelle: "2025/2026" },
];

const serie = [
  {
    Code_serie: "2A",
    Titre: "LLA",
    Libelle: "Lettres, Langues et Arts",
  },
  {
    Code_serie: "2B",
    Titre: "SES",
    Libelle: "Sciences Economiques et Sociales",
  },
  {
    Code_serie: "2C",
    Titre: "SMP",
    Libelle: "Sciences, Mathématiques et Physique",
  },
  {
    Code_serie: "2D",
    Titre: "SVT",
    Libelle: "Sciences de la Vie et de la Terre",
  },
];

const serie_m = [
  {
    Code_serie: "1E",
    Titre: "LLA",
    Libelle: "Lettres, Langues et Arts",
  },
  {
    Code_serie: "1B",
    Titre: "SES",
    Libelle: "Sciences Economiques et Sociales",
  },
  {
    Code_serie: "1C",
    Titre: "SMP",
    Libelle: "Sciences, Mathématiques et Physique",
  },
  {
    Code_serie: "1D",
    Titre: "SVT",
    Libelle: "Sciences de la Vie et de la Terre",
  },
];

const section = [
  {
    Code_section: "2A",
    Libelle: "Philo A",
  },
  {
    Code_section: "2B",
    Libelle: "Philo B",
  },
  {
    Code_section: "2C",
    Libelle: "Philo C",
  },
  {
    Code_section: "2D",
    Libelle: "Philo D",
  },
];

const zones = [
  { code: "001", libelle: "Zone 01" },
  { code: "002", libelle: "Zone 02" },
  { code: "003", libelle: "Zone 03" },
  { code: "004", libelle: "Zone 04" },
  { code: "005", libelle: "Zone 05" },
  { code: "006", libelle: "Zone 06" },

  { code: "007", libelle: "Zone 07" },
  { code: "008", libelle: "Zone 08" },
  { code: "009", libelle: "Zone 09" },
  { code: "010", libelle: "Zone 10" },
  { code: "011", libelle: "Zone 11" },
  { code: "012", libelle: "Zone 12" },
  { code: "013", libelle: "Zone 13" },
  { code: "014", libelle: "Zone 14" },
  { code: "015", libelle: "Zone 15" },
  { code: "016", libelle: "Zone 16" },
  { code: "017", libelle: "Zone 17" },
  { code: "018", libelle: "Zone 18" },
  { code: "019", libelle: "Zone 19" },
  { code: "020", libelle: "Zone 20" },
];
let afficher_champs = true;
//const url_ = 'http://192.168.43.83:8086/api';
// const url_ = 'https://192.168.27.235:8443';
//const url_ = 'http://192.168.27.235:8086/api';
//const url_ = 'http://192.168.0.43:8086/api';
//const url_ = 'http://10.50.57.234:8086';

const url_ = "/api";
// const url_ = 'http://10.50.57.234:8086/api';
// const url_ = 'http://192.168.0.111:8086/api';
// ?const url_ = 'https://nbiuc35pmj.sharedwithexpose.com';
//const url_ = "http://192.168.1.7:8086/api";
//const url_ = "http://localhost:8086/api";
//const url_ = "https://bunexe.work/api";

let ecole_selection = {};

const Bunexe_service = {
  depts: depts,
  serie: serie,
  zones: zones,
  ecole_selection: ecole_selection,
  section: section,
  url: url_,
  Annee_academique: Annee_academique,
  afficher_champs: afficher_champs,
  annee_encours: "( 2025-2026 )",
  an_ns2: "( 2023-2024 )",
  an_ns3: "( 2024-2025 )",
};
export default Bunexe_service;
